export default "__VITE_ASSET__d8313584__"